<template>
  <transition
    name="fade"
    mode="out-in"
    appear
  >
    <router-link
      :id="residence.slug"
      :to="route"
      :class="css"
      @mouseover.native.stop="toggleFocus(true)"
      @mouseout.native.stop="toggleFocus(false)"
      @focus.native.stop="toggleFocus(true)"
      @focusout.native.stop="toggleFocus(false)"
      class="c-residence"
      tabindex="0"
      itemscope
      itemtype="http://schema.org/Product"
    >
      <p
        v-if="showBanner"
        class="c-residence__banner"
      >
        Solgt
      </p>
      <template v-if="listType === 'cards'">
        <template v-if="residence.hasImages === true">
          <card-image
            v-if="residence.images.length > 0"
            :id="residence.images[0].id"
            :image="residence.images[0]"
            itemprop="image"
          />
          <spinner
            v-else
            class="c-spinner c-spinner--card"
          />
        </template>
        <MissingImage v-else />
      </template>
      <header class="c-residence__header">
        <h2
          class="c-residence__name"
          itemprop="name"
        >
          {{ residence.name }}
        </h2>
        <p
          class="c-residence__price"
          itemprop="offers"
          itemscope
          itemtype="http://schema.org/Offer"
        >
          <link
            itemprop="itemCondition"
            href="http://schema.org/NewCondition"
          />
          {{ priceInfo }}
          <span
            itemprop="availability"
            content="https://schema.org/InStock"
          />
          <span
            itemprop="price"
            :content="residence.totalPrice"
          />
          <span
            itemprop="priceCurrency"
            content="NOK"
          />
        </p>
      </header>
      <ul
        v-if="type || bedrooms || size"
        class="c-residence__facts"
      >
        <li
          v-if="type"
          class="c-residence__fact"
        >
          {{ type }}
        </li>
        <li
          v-if="bedrooms"
          class="c-residence__fact"
        >
          {{ bedrooms }}
        </li>
        <li
          v-if="size"
          class="c-residence__fact"
        >
          {{ size }}
        </li>
      </ul>
    </router-link>
  </transition>
</template>

<script>
import { EventBus } from '@/event-bus.js';

// UI Components
import CardImage from '@/components/CardImage.vue';
import Spinner from '@/components/Spinner.vue';
import MissingImage from '@/components/MissingImage.vue';

export default {
  name: 'ResidenceItem',
  components: {
    CardImage,
    Spinner,
    MissingImage,
  },
  props: {
    showImg: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      required: true,
    },
    residence: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      hasFocus: false,
    };
  },
  computed: {
    section_id() {
      return this.residence.sections[0].id;
    },
    route() {
      return `bolig/${this.residence.slug}`;
    },
    priceInfo() {
      return this.residence.priceInfo;
    },
    type() {
      return this.residence.residenceType
        ? this.residence.residenceType.name
        : false;
    },
    bedrooms() {
      return this.residence.bedrooms
        ? `Soverom: ${this.residence.bedrooms.name}`
        : false;
    },
    illustrationIds() {
      let ids = [];
      this.residence.shapes.forEach(shape => {
        ids.push(shape.illustration);
      });
      return ids;
    },
    size() {
      if (this.residence.bra_i) {
        return `BRA-i: ${this.residence.bra_i.toLocaleString('nb-NO')}\xa0m²`;
      } else if (this.residence.size) {
        return `BRA: ${this.residence.size.toLocaleString('nb-NO')}\xa0m²`;
      } else {
        return false;
      }
    },
    listType() {
      return this.$store.state.entities.residences.listType;
    },
    css() {
      const availability = this.residence.availability;
      let classes = '';
      if (availability) {
        classes += 'is-' + availability.slug;
      } else {
        classes += 'is-none';
      }
      if (this.hasFocus === true) {
        classes += ' has-focus';
      }
      if (this.listType === 'cards') {
        classes += ' c-residence--card';
      }
      return classes;
    },
    showBanner() {
      const bannerSetting = this.$store.state.entities.selectors.showBanner;
      return this.listType === 'cards' &&
        this.residence.availability.slug === 'sold' &&
        bannerSetting
        ? true
        : false;
    },
  },
  created() {
    EventBus.$on('residence-focus', residenceFocus => {
      if (residenceFocus.id === this.residence.id) {
        this.hasFocus = residenceFocus.hasFocus;
      }
    });
  },
  methods: {
    toggleFocus(focus) {
      EventBus.$emit('residence-focus', {
        hasFocus: focus,
        id: this.id,
        illustrationIds: this.illustrationIds,
      });
      if (this.section_id) {
        EventBus.$emit('section-focus', {
          hasFocus: focus,
          id: this.section_id,
        });
      }
    },
  },
};
</script>
